<template lang="pug">
v-container(fluid class=" tw-h-full tw-overflow-hidden tw-rounded tw-pt-0 tw-pb-0" style="background: #f5f5fa")
  div(class="tw-flex tw-flex-col tw-h-full  tw-pb-0")
    div(class="tw-flex tw-flex-row tw-bg-white tw-rounded-md tw-px-3")
      v-row(no-gutters justify="end" align="center")
        v-col
          v-btn-toggle(v-model="toggle_exclusive" mandatory)
            v-btn(small @click="setFilter('all')" depressed color="rgba(94,129,244,0.10)" class="tw-rounded-md")
              span(class="tw-font-medium tw-pl-1 tw-text-kPurple") {{ $t('Common.all') }}
            v-btn(small @click="setFilter('user')" depressed color="rgba(94,129,244,0.10)" class="tw-rounded-md")
              span(class="tw-font-medium tw-pl-1 tw-text-kPurple") {{ $t('Opportunities.Common.myOpportunities') }}
        v-col(cols="auto")
          v-btn(v-if="!$vuetify.breakpoint.mobile" depressed color="rgba(94,129,244,0.80)" @click="addDialogToggle")
            span(class="tw-font-bold") {{ $t('Opportunities.Common.addOpportunity') }}
          v-btn(
            v-if="$vuetify.breakpoint.mobile"
            depressed
            fab
            small
            color="rgba(94,129,244,0.80)"
            @click="addDialogToggle"
          )
            v-icon mdi-plus
    div(v-if="!loading && loaded && opportunities.length === 0" class="tw-flex tw-flex-grow tw-bg-white tw-mt-4 tw-rounded-md")
      kubiqa-misc-empty-state(
        :title="$t('Common.emptyStates.opportunitiesTitle')"
        :description="$t('Common.emptyStates.opportunitiesBody')"
        icon="mdi-handshake-outline"
      )
    div(v-else-if="!loading && !loaded" class="tw-flex tw-flex-grow tw-bg-white tw-mt-4 tw-rounded-md")
      kubiqa-misc-empty-state(
        :title="$t('Common.emptyStates.loadErrorTitle')"
        :description="$t('Common.emptyStates.loadErrorBody')"
        :action-label="$t('Common.emptyStates.retry')"
        icon="mdi-alert-circle-outline"
        @action="init"
      )
    template(v-else-if="!$vuetify.breakpoint.mobile")
      div(class="tw-flex tw-flex-row tw-justify-between tw-flex-grow tw-overflow-y-auto tw-py-4 tw-bg-white tw-mt-4 tw-rounded-md")
        v-row(dense align="stretch" no-gutters class="tw-h-full tw-py-4 tw-px-2")
          // Qualify
          v-col(cols="12" md="" class="swimLaneContainer")
            v-row(class=" tw-w-auto mx-0 tw-py-2")
              v-col(class="tw-mb-0 tw-pb-1 ")
                v-row(no-gutters align="center" class="label-qualify tw-rounded-lg tw-py-2 tw-px-2")
                  v-col
                    div
                      span(class="tw-text-lg tw-text-left tw-font-bold tw-text-white pl-1 tw-capitalize") {{ $t('Opportunities.Common.qualify') }}
                  v-col(cols="auto")
                    div(class="tw-bg-white text-secondary tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-font-bold")
                      span {{ qualify.length }}
            v-row(class="tw-w-auto mx-0 tw-max-h-full tw-h-full tw-overflow-scroll   ")
              v-col(class="tw-w-auto pt-0 ")
                template(v-if="!loading")
                  draggable(
                    class="list-group tw-h-full"
                    id="1"
                    :list="qualify"
                    group="opportunities"
                    @change="(event) => checkMove(event, 'qualify')"
                    v-bind="dragOptions"
                  )
                  kubiqa-misc-empty-state(
                    v-if="!loading && qualify.length === 0"
                    :title="$t('Common.emptyStates.stageTitle')"
                    compact
                    icon="mdi-tray-remove"
                  )
                  div(v-else v-for="(item, index) in qualify" :key="item.id")
                    div(class=" tw-cursor-move" @click="viewDetail(item)")
                      kubiqa-opportunities-preview(:item="item")
                    div(v-if="index == qualify.length - 1" class=" tw-pb-12")
                template(v-else)
                  div(v-for="i in this.$faker().datatype.number({ min: 1, max: 6 })" :key="i")
                    kubiqa-opportunities-preview-loader

          // Pitch
          v-col(cols="12" md="" class="swimLaneContainer")
            v-row(class=" tw-w-auto mx-0 tw-py-2")
              v-col(class="tw-mb-0 tw-pb-1 ")
                v-row(no-gutters align="center" class="label-pitch tw-rounded-lg tw-py-2 tw-px-2")
                  v-col
                    div
                      span(class="tw-text-lg tw-text-left tw-font-bold tw-text-white pl-1 tw-capitalize") {{ $t('Opportunities.Common.pitch') }}
                  v-col(cols="auto")
                    div(class="tw-bg-white text-secondary tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-font-bold")
                      span {{ pitch.length }}
            v-row(class=" tw-w-auto mx-0 tw-max-h-full tw-h-full tw-overflow-scroll tw-pb-10 ")
              v-col(class="tw-w-auto pt-0")
                template(v-if="!loading")
                  draggable(
                    class="list-group tw-h-full"
                    id="2"
                    :list="pitch"
                    group="opportunities"
                    @change="(event) => checkMove(event, 'pitch')"
                    v-bind="dragOptions"
                  )
                  kubiqa-misc-empty-state(
                    v-if="!loading && pitch.length === 0"
                    :title="$t('Common.emptyStates.stageTitle')"
                    compact
                    icon="mdi-tray-remove"
                  )
                  div(v-else v-for="(item, index) in pitch" :key="item.id")
                    div(class=" tw-cursor-move" @click="viewDetail(item)")
                      kubiqa-opportunities-preview(:item="item")
                    div(v-if="index == pitch.length - 1" class=" tw-pb-12")
                template(v-else)
                  div(v-for="i in this.$faker().datatype.number({ min: 1, max: 6 })" :key="i")
                    kubiqa-opportunities-preview-loader
            v-row(class="tw-h-4 tw-bg-red")
              v-col(class="tw-h-24")

          // Negotiate
          v-col(cols="12" md="" class="swimLaneContainer")
            v-row(class=" tw-w-auto mx-0 tw-py-2")
              v-col(class="tw-mb-0 tw-pb-1 ")
                v-row(no-gutters align="center" class="label-negotiate tw-rounded-lg tw-py-2 tw-px-2")
                  v-col
                    div
                      span(class="tw-text-lg tw-text-left tw-font-bold tw-text-white pl-1 tw-capitalize") {{ $t('Opportunities.Common.negotiate') }}
                  v-col(cols="auto")
                    div(class="tw-bg-white text-secondary tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-font-bold")
                      span {{ negotiate.length }}
            v-row(class="tw-w-auto mx-0 tw-max-h-full tw-h-full tw-overflow-scroll")
              v-col(class="tw-w-auto pt-0")
                template(v-if="!loading")
                  draggable(
                    class="list-group tw-h-full"
                    id="3"
                    :list="negotiate"
                    group="opportunities"
                    @change="(event) => checkMove(event, 'negotiate')"
                    v-bind="dragOptions"
                  )
                  kubiqa-misc-empty-state(
                    v-if="!loading && negotiate.length === 0"
                    :title="$t('Common.emptyStates.stageTitle')"
                    compact
                    icon="mdi-tray-remove"
                  )
                  div(v-else v-for="(item, index) in negotiate" :key="item.id")
                    div(class=" tw-cursor-move" @click="viewDetail(item)")
                      kubiqa-opportunities-preview(:item="item")
                    div(v-if="index == negotiate.length - 1" class=" tw-pb-12")
                template(v-else)
                  div(v-for="i in this.$faker().datatype.number({ min: 1, max: 6 })" :key="i")
                    kubiqa-opportunities-preview-loader

          // Close
          v-col(cols="12" md="" class="swimLaneContainer")
            v-row(class=" tw-w-auto mx-0 tw-py-2")
              v-col(class="tw-mb-0 tw-pb-1 ")
                v-row(no-gutters align="center" class="label-close tw-rounded-lg tw-py-2 tw-px-2 ")
                  v-col
                    div
                      span(class="tw-text-lg tw-text-left tw-font-bold tw-text-white pl-1 tw-capitalize") {{ $t('Opportunities.Common.close') }}
                  v-col(cols="auto")
                    div(class="tw-bg-white text-secondary tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-font-bold")
                      span {{ close.length }}
            v-row(class=" tw-w-auto mx-0 tw-max-h-full tw-h-full tw-overflow-scroll")
              v-col(class=" tw-w-auto pt-0")
                template(v-if="!loading")
                  draggable(
                    class="list-group tw-h-full"
                    id="4"
                    :list="close"
                    group="opportunities"
                    @change="(event) => checkMove(event, 'close')"
                    v-bind="dragOptions"
                  )
                  kubiqa-misc-empty-state(
                    v-if="!loading && close.length === 0"
                    :title="$t('Common.emptyStates.stageTitle')"
                    compact
                    icon="mdi-tray-remove"
                  )
                  div(v-else v-for="(item, index) in close" :key="item.id")
                    div(class=" tw-cursor-move" @click="viewDetail(item)")
                      kubiqa-opportunities-preview(:item="item")
                    div(v-if="index == close.length - 1" class=" tw-pb-12")
                template(v-else)
                  div(v-for="i in this.$faker().datatype.number({ min: 1, max: 6 })" :key="i")
                    kubiqa-opportunities-preview-loader
    div(v-else-if="loading && $vuetify.breakpoint.mobile" class="tw-flex tw-h-full tw-items-center tw-justify-center")
      v-progress-circular(indeterminate color="primary" size="48" aria-label="Loading opportunities")
    div(v-else-if="opportunities.length > 0" class="tw-pt-4")
      v-expansion-panels(flat)
        v-expansion-panel(
          v-for="(stage, index) in stages"
          :key="index"
          class="tw-border tw-border-gray-lighten-4 tw-rounded-md"
          :activeClass="`label-` + stage.name + ` tw-rounded-md`"
        )
          v-expansion-panel-header(:class="`label-` + stage.name" class="tw-rounded-md" class="tw-text-white")
            v-row(align="center")
              v-col(cols="")
                span(class="tw-text-lg tw-text-left tw-font-bold tw-text-white pl-1 tw-capitalize") {{ stage.label }}
              v-col(cols="3" class="pr-4 text-center")
                div(class="tw-bg-white text-secondary tw-rounded-lg tw-px-2 tw-py-2 tw-text-sm tw-font-bold")
                  span {{ getStageItems(stage.name).length }}
          v-expansion-panel-content(class="tw-bg-white pa-0 ma-0 opportinuty-panel")
            div(v-for="(opp, index) in getStageItems(stage.name)" :key="index")
              div(@click="viewDetail(opp)" class="tw-bg-red")
                kubiqa-opportunities-preview(:item="opp")
              div(v-if="index == getStageItems(stage.name).length - 1" class=" tw-pb-5")
  v-dialog(
    v-model="closeOpportunityDialog"
    :fullscreen="!$vuetify.breakpoint.mobile ? false : true"
    width="30%"
    max-width="30%"
  )
    div(class="tw-bg-white tw-h-full close-opp-modal")
      kubiqa-opportunities-edit-close-dialog(
        @close="(closeOpportunityDialog = false), init()"
        :opportunity="current_opportunity"
        :key="key"
      )
  v-dialog(
    v-model="addDialog"
    :fullscreen="!$vuetify.breakpoint.mobile ? false : true"
    width="75%"
    max-width="75%"
    class="tw-h-full tw-bg-green-base"
  )
    div(class="tw-bg-white tw-h-full add-listing-modal")
      kubiqa-opportunities-add(:key="key" :relate="false" @close="addDialogToggle" class="tw-h-full ")
</template>
<script>
export default {
  data() {
    return {
      qualify: [],
      opportunities: [],
      pitch: [],
      negotiate: [],
      close: [],
      stages: [
        { id: 1, name: 'qualify', label: this.$t('Opportunities.Common.qualify') },
        { id: 2, name: 'pitch', label: this.$t('Opportunities.Common.pitch') },
        { id: 3, name: 'negotiate', label: this.$t('Opportunities.Common.negotiate') },
        { id: 4, name: 'close', label: this.$t('Opportunities.Common.close') },
      ],
      dialogOppDetail: false,
      oppDetail: null,
      closeOpportunityDialog: false,
      current_opportunity: null,
      key: 1,
      loading: true,
      loaded: false,
      addDialog: false,
      toggle_exclusive: undefined,
      filter: 'all',
    };
  },
  created() {
    this.$store.commit('displaySidebar', true);
    this.$store.commit('displayWebsiteToolbar', false);
    this.$store.commit('displayMainToolbar', true);
  },
  async mounted() {
    this.init();
  },
  computed: {
    dragOptions() {
      return {
        animation: 400,
        group: 'images',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    async init() {
      this.loading = true;
      let params = new URLSearchParams();
      params.append('sort', 'order');
      if (this.filter == 'user') {
        params.append('filter[user_id]', this.$store.getters['auth/authUser'].id);
      }
      await this.$store
        .dispatch('opportunities/list', params)
        .then((response) => {
          this.loaded = Array.isArray(response);
          this.opportunities = Array.isArray(response) ? response : [];
          this.qualify = this._.filter(this.opportunities, function (opportunity) {
            return opportunity.stage == 1;
          });
          this.pitch = this._.filter(this.opportunities, function (opportunity) {
            return opportunity.stage == 2;
          });
          this.negotiate = this._.filter(this.opportunities, function (opportunity) {
            return opportunity.stage == 3;
          });
          this.close = this._.filter(this.opportunities, function (opportunity) {
            return opportunity.stage == 4;
          });
          this.getFunnelValues();
        })
        .catch((error) => {
          this.loaded = false;
          this.$store.commit('SET_ERROR', error, { root: true });
        });
      this.loading = false;
    },
    checkMove(evt, column) {
      if (!evt.removed) {
        this.opportunities = [];
        this.qualify.forEach((element, index) => {
          let item = {};
          element.closed_stage = null;
          item.stage = 1;
          item.id = element.id;
          item.order = index;
          item.closed_date = null;
          item.closing_notes = null;
          item.closed_state = null;
          this.opportunities.push(item);
        });
        this.pitch.forEach((element, index) => {
          let item = {};
          element.closed_stage = null;
          item.stage = 2;
          item.id = element.id;
          item.order = index;
          item.closed_date = null;
          item.closing_notes = null;
          item.closed_state = null;
          this.opportunities.push(item);
        });
        this.negotiate.forEach((element, index) => {
          let item = {};
          element.closed_stage = null;
          item.stage = 3;
          item.id = element.id;
          item.order = index;
          item.closed_date = null;
          item.closing_notes = null;
          item.closed_state = null;
          this.opportunities.push(item);
        });
        this.close.forEach((element, index) => {
          let item = {};
          item.stage = 4;
          item.id = element.id;
          item.order = index;
          this.opportunities.push(item);
        });
        this.$store.dispatch('opportunities/bulkUpdate', this.opportunities);
        if (evt.added && column == 'close') {
          evt.added.element.stage = 4;
          this.current_opportunity = JSON.parse(JSON.stringify(evt.added.element));
          this.closeOpportunityDialog = true;
          this.key++;
        }
        this.getFunnelValues();
      }
    },
    getFunnelValues() {
      let funnelValues = {
        qualify: 0,
        pitch: 0,
        negotiate: 0,
        close: 0,
      };
      this.qualify.forEach((element) => {
        funnelValues.qualify += parseInt(element.amount);
      });
      this.pitch.forEach((element) => {
        funnelValues.pitch += parseInt(element.amount);
      });
      this.negotiate.forEach((element) => {
        funnelValues.negotiate += parseInt(element.amount);
      });
      this.close.forEach((element, index) => {
        funnelValues.close += parseInt(element.amount);
      });
      this.$store.commit('opportunities/SET_FUNNEL_VALUES', funnelValues);
    },
    viewDetail: function (opp) {
      this.$router.push({ name: 'opportunityDetail', params: { id: opp.id } });
    },
    addDialogToggle() {
      this.key++;
      this.addDialog = !this.addDialog;
    },
    setFilter(filter) {
      this.filter = filter;
      this.init();
    },
    getStageItems(stageName) {
      // Return the array that matches the stage’s name
      return this[stageName] || [];
    },
  },
};
</script>

<style lang="stylus">

.swimLaneContainer{
    @apply tw-mx-2 tw-border tw-border-dashed tw-border-gray-lighten-1 px-0 py-0 tw-max-h-full tw-overflow-hidden tw-rounded-md;
}

.ghost
    opacity: 0.5
    background: #ffffff

.opportunity-panel .v-expansion-panel-content__wrap
    padding: 0 !important
    margin: 0 !important


.opportinuty-panel
    height: 350px !important;
    overflow-y: auto !important;
</style>
